<ridango-ui-ticket-wrapper [isPending]="isPending" [label]="label">
    <div class="margin-bottom-20" header>
        <ridango-ui-ticket-block [position]="'left'">
            <ridango-ui-ticket-block-item [label]="'PICKUP' | translate">
                {{ plan.pickupFeature?.address }}
            </ridango-ui-ticket-block-item>
            <ridango-ui-ticket-block-item [label]="'DROPOFF' | translate">
                {{ plan.dropoffFeature?.address }}
            </ridango-ui-ticket-block-item>
        </ridango-ui-ticket-block>

        <ridango-ui-ticket-block [position]="'right'">
            <ridango-ui-ticket-block-item
                *ngIf="plan.priority === priorityType.PICKUP"
                [label]="'PLAN_RIDE_PRIORITY' | translate"
                [isFullWidth]="true">
                {{ plan.dateAndTime | date: dateFormat || 'dd.MM.y HH:mm' }}<br />({{ 'PICKUP' | translate }})
            </ridango-ui-ticket-block-item>

            <ridango-ui-ticket-block-item
                *ngIf="plan.priority === priorityType.DROPOFF"
                [label]="'PLAN_RIDE_PRIORITY' | translate"
                [isFullWidth]="true">
                {{ plan.dateAndTime | date: dateFormat || 'dd.MM.y HH:mm' }}<br />({{ 'DROPOFF' | translate }})
            </ridango-ui-ticket-block-item>
        </ridango-ui-ticket-block>

        <ridango-ui-ticket-block *ngIf="plan.stopovers?.length > 0" [position]="'left'">
            <ridango-ui-ticket-block-item [label]="'PLAN_RIDE_FIRST_STOPOVER' | translate">
                {{ plan.stopovers[0].properties?.formatted }}
            </ridango-ui-ticket-block-item>
            <ridango-ui-ticket-block-item></ridango-ui-ticket-block-item>
        </ridango-ui-ticket-block>

        <ridango-ui-ticket-block [position]="'right'"></ridango-ui-ticket-block>
    </div>

    <ridango-ui-ticket-block [position]="'left'" [ngSwitch]="estimatedPrice">
        <ridango-ui-ticket-block-item
            *ngSwitchDefault
            [label]="'BOOKING_SUMMARY_SPECIFY_TITLE' | translate"
            [isSecondaryValue]="true">
            {{ estimatedPrice | moneyFormat }} {{ appStartupService.getCurrency() | translate }}
        </ridango-ui-ticket-block-item>

        <ridango-ui-ticket-block-item
            *ngSwitchCase="infinity"
            [label]="'BOOKING_SUMMARY_SPECIFY_TITLE' | translate"
            [isSecondaryValue]="true">
            {{ 'RIDE_WAITING_CONFIRMATION' | translate }}
        </ridango-ui-ticket-block-item>

        <ridango-ui-ticket-block-item
            *ngIf="passengerPermission && specification.companion > 0"
            [label]="'TABLE_HEADER_PASSENGER' | translate"
            [isSecondaryValue]="true">
            {{ customerProfile.name }} (+ {{ specification.companion }})
        </ridango-ui-ticket-block-item>

        <ridango-ui-ticket-block-item
            *ngIf="passengerPermission && specification.companion === 0"
            [label]="'TABLE_HEADER_PASSENGER' | translate"
            [isSecondaryValue]="true">
            {{ customerProfile.name }}
        </ridango-ui-ticket-block-item>
    </ridango-ui-ticket-block>
    <ridango-ui-ticket-block [position]="'right'"></ridango-ui-ticket-block>

    <ridango-ui-ticket-block *ngIf="specification.additionalInformation" [position]="'left'">
        <ridango-ui-ticket-block-item
            [label]="'ADDITIONAL_INFORMATION_TITLE' | translate"
            [isFullWidth]="true"
            [isSecondaryValue]="true">
            {{ specification.additionalInformation }}
        </ridango-ui-ticket-block-item>
    </ridango-ui-ticket-block>
    <ridango-ui-ticket-block [position]="'right'"></ridango-ui-ticket-block>
</ridango-ui-ticket-wrapper>
